import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface StyledProps {
  grey: boolean;
  transparent: boolean;
  compact: boolean;
}

interface MessageProps {
  padding?: number;
  backgroundImage?: boolean;
}

export const EmptyInfo = styled.div<Partial<StyledProps>>`
  padding-top: ${({ compact }) => (compact ? '0' : '100px')};
  text-align: center;
  padding-bottom: 30px;
`;

export const EmptyContainer = styled.div.attrs<any, StyledProps>(({ grey, transparent, compact }): any => ({
  grey,
  transparent,
  compact,
}))`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: ${({ compact }) => (compact ? 'auto' : '100%')};
  margin-top: ${({ compact }) => (compact ? 10 : 0)}px;

  background-color: ${({ grey, theme, transparent }) =>
    grey ? theme.emptyList.greyBackground : transparent ? ColorPalette.Transparent : theme.emptyList.whiteBackground};

  @media ${({ theme }) => theme.device.desktop} {
    margin: auto;
    background-color: ${ColorPalette.Transparent};
  }
`;

export const EmptyTitle = styled.div`
  margin-top: 30px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme }) => theme.primaryBackgroundColor};
`;

export const EmptyImage = styled.img`
  height: 70px;
  max-width: 110px;
`;

export const BackgroundImage = styled.img`
  width: 100%;
`;

export const EmptyMessage = styled.div.attrs<any, MessageProps>({})`
  font-size: 14px;
  color: ${({ theme }) => theme.emptyList.descriptionColor};
  text-align: center;
  padding-top: ${({ backgroundImage }) => (backgroundImage ? '100px' : '24px')};
  padding-right: ${({ padding }) => (padding !== undefined ? padding : '90')}px;
  padding-left: ${({ padding }) => (padding !== undefined ? padding : '90')}px;
  line-height: 1.43;
`;

export const BgImage = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-top: auto;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-image: url('/corporate/images/clouds.svg'), ${({ theme }) => theme.emptyList.imageBackgroundGradient};
  background-position: -218px -5%, 0 120px;
  background-repeat: repeat-x, no-repeat, no-repeat;
  height: 362px;

  @media (min-width: 360px) {
    background-position: -218px 0, 0 170px;
  }
`;
